import { render, staticRenderFns } from "./salesSummaryNoDelivery.vue?vue&type=template&id=5976be02&scoped=true&"
import script from "./salesSummaryNoDelivery.vue?vue&type=script&lang=js&"
export * from "./salesSummaryNoDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976be02",
  null
  
)

export default component.exports